import React from 'react'
import Slider from './Slider'
import Counter from './Counter'
import Work from './Work'
import Features from './Features'

function Home() {
  return (
    <div>
      <Slider/>
      <Counter/>
      <Work/>
      <Features/>
    </div>
  )
}

export default Home
